<h2 mat-dialog-title>Download Dataset</h2>
<mat-dialog-content>
  <p class="mb-2">Please cite this dataset as:</p>
  <blockquote class="citation-text">{{ data.citationText }}</blockquote>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Download</button>
</mat-dialog-actions>
